import React, { Fragment } from 'react';
import { array, string, object, func } from 'prop-types';

import Log from './list-item';
import { DividerS } from './styles';

const LogsList = ({
  logs,
  requestId,
  authorizedUser,
  handleLogDelete,
}) => (
  <Fragment>
    {logs.map((log, index) => (
      <Fragment key={log._id}>
        <Log
          {...log}
          {...requestId}
          number={index + 1}
          authorizedUser={authorizedUser}
          handleLogDelete={handleLogDelete}
        />
        { index < logs.length - 1 && <DividerS /> }
      </Fragment>
    ))}
  </Fragment>
);
LogsList.propTypes = {
  logs: array,
  requestId: string.isRequired,
  authorizedUser: object.isRequired,
  handleLogDelete: func.isRequired,
};

LogsList.defaultProps = {
  logs: [],
};

export default LogsList;



// WEBPACK FOOTER //
// ./src/components/logs-simple-list/index.js